<template>
    <div class="fill-screen">
        <div class="logo">
            <!-- <img src="http://www.yibaicdn.com/d1c23f90-8b25-11e9-a215-4bc0baf4a45a.png"> -->
            <div>信息管理平台</div>
        </div>
        <div class="login-icon">
            <img src="https://cdn.dhlz.com.cn/login/login_bg.png">
        </div>
        <div class="login-container">
            <el-form label-width="0px">
                <div class="title">欢迎使用信息管理平台</div>
                <el-form-item prop="username">
                    <el-input @keyup.native.enter="loginAction" type="text" v-model="account.username" clearable
                        placeholder="登录账号">
                        <img class="input-prefix" slot="prefix" src="https://cdn.dhlz.com.cn/login/login_username.png">
                    </el-input>
                </el-form-item>
                <el-form-item prop="password">
                    <el-input @keyup.native.enter="loginAction" type="password" v-model="account.password" clearable
                        placeholder="登录密码">
                        <img class="input-prefix" slot="prefix" src="https://cdn.dhlz.com.cn/login/login_password.png">
                    </el-input>
                </el-form-item>
                <el-form-item class="fill-width">
                    <el-button type="primary" class="login-btn fill-width" @click.prevent="loginAction"
                        :loading="logining">登&nbsp;&nbsp;录</el-button>
                </el-form-item>
            </el-form>
        </div>
        <a href="https://beian.miit.gov.cn/" target="_blank" class="beian">
            <span class="fanda">皖ICP备2023007812号</span>
        </a>
    </div>
</template>

<script>
import { loginState } from "../util/login";
import { HttpClient } from "../util/http";
import { actionConfirm, msgSuccess } from "../util/toast";

export default {
    data() {
        return {
            logining: false,
            account: {
                username: "",
                password: "",
            },
        };
    },
    created() {},
    methods: {
        async loginAction() {
            if (
                this.account.username.length > 0 &&
                this.account.password.length > 0
            ) {
                this.logining = true;
                try {
                    await loginState.login(this.account);
                    this.$notify.success("登录成功");
                    this.$router.replace("/");
                } finally {
                    this.logining = false;
                }
            }
        },
    },
};
</script>

<style scoped lang="less">
.beian {
    position: absolute;
    font-size: 12px;
    // bottom: 20px;
    // right: 20px;
    left: 50%;
    bottom: 15px;
    transform: translate(-50%, -50%);
    color: rgba(255, 255, 255, 0.7);
}
.fill-screen {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-image: url(https://cdn.dhlz.com.cn/login/login_bg_full.png);
    background-size: 100vw 100vh;
    z-index: 1000;
    display: flex;
    align-items: center;
    justify-content: space-around;
    .logo {
        position: absolute;
        left: 60px;
        top: 40px;
        display: flex;
        align-items: center;
        > img {
            height: 70px;
        }
        > div {
            margin-left: 20px;
            color: white;
            font-size: 27px;
            font-weight: bold;
        }
    }
    .login-icon {
        margin-left: 20px;
        width: 600px;
        height: auto;
        > img {
            width: 100%;
            height: auto;
        }
    }
    .login-container {
        border: none !important;
        width: 300px;
        font-size: 18px;
        background: white;
        border-radius: 5px;
        padding: 0 35px;
        padding-bottom: 10px;
        box-shadow: 2px 2px 40px rgba(0, 0, 0, 0.3);
        .title {
            font-size: 20px;
            font-weight: bold;
            line-height: 20px;
            padding-left: 10px;
            border-left: 7px solid #a1a4ac;
            margin-top: 25px;
            margin-bottom: 25px;
            color: #909399;
        }
        .login-btn {
            margin-top: 15px;
            font-size: 16px;
            background-color: #2a86e2;
            box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.3);
            &:hover {
                opacity: 0.8;
            }
        }
        .input-prefix {
            margin-top: 11px;
            margin-left: 2px;
            width: 18px;
            height: 18px;
        }
    }
}

@media screen and (max-width: 768px) {
    .login-container {
        width: 50vw;
    }
}
</style>
